import constants from "../constants";
import socket from "../socket";

// ЛАФЧЕ.ORG: /clear е чисто клиентска команда (не сървърен plugin), затова
// не идва естествено от сървъра - добавяме я ръчно към списъка, за да се
// показва в autocomplete-а точно като останалите команди. ВАЖНО: сървърният
// списък пази командите С "/" префикс (напр. "/join"), затова трябва да
// съвпаднем с този формат.
const clientOnlyCommands = ["/clear"];

socket.on("commands", function (commands) {
	if (commands) {
		constants.commands = commands.concat(clientOnlyCommands);
	}
});
